import api from './apiConfig';

const GERMAN_COURSE_ID = "edc49760debb11f08cdde3d082e8673b";

// Management Monitoring API
// Base: /frontsite-api/v1/management/monitoring
// Auth: Authorization: Bearer <management/admin JWT>
// Notes: Middleware tetep wajib walaupun controller ga baca `:identity`.

// GET /phases
// Ngambil semua program phases yang tersedia buat dashboard monitoring
// Data otomatis di-sort berdasarkan name
// Response: { status: "ok", message: "...", data: [...] }
export const getPhases = async () => {
  try {
    const response = await api.get('/frontsite-api/v1/management/monitoring/phases');
    return {
      success: response.data?.status === 'ok',
      data: response.data?.data || [],
      message: response.data?.message,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || 'Failed to fetch phases',
      data: [],
    };
  }
};

// POST /subcourses
// Ngambil list subcourse berdasarkan course-id tertentu
// Request: { data: { "course-id": "..." } }
// Response: { status: "ok", message: "...", data: [...] }
export const getSubcourses = async (courseId = GERMAN_COURSE_ID) => {
  if (!courseId) {
    return {
      success: false,
      message: 'course-id is required',
      data: [],
    };
  }
  try {
    const response = await api.post('/frontsite-api/v1/management/monitoring/subcourses', {
      data: { 'course-id': courseId },
    });
    return {
      success: response.data?.status === 'ok',
      data: response.data?.data || [],
      message: response.data?.message,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || 'Failed to fetch subcourses',
      data: [],
    };
  }
};

// POST /get-learner-progress2
// Ambil agregasi progres per course
// Logic bakal breakdown level jadi level + progress biar gampang dibaca di UI
// Request: { data: { "course-id": "...", "rombel-id": "..." } }
// Response: { status: "ok", message: "...", data: [...] }
export const getLearnerProgress = async (courseId = GERMAN_COURSE_ID, rombelId = null) => {
  if (!courseId) {
    return {
      success: false,
      message: 'course-id is required',
      data: [],
    };
  }
  try {
    const requestBody = { 
      'course-id': courseId,
      'rombel-id': rombelId || ''
    };
    const response = await api.post('/frontsite-api/v1/monitoring/get-learner-progress2', {
      data: requestBody,
    });
    return {
      success: response.data?.status === 'ok',
      data: response.data?.data || [],
      message: response.data?.message,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || 'Failed to fetch learner progress',
      data: [],
    };
  }
};

// Learner Leaderboard API
// Base: /frontsite-api/v1/learner/leaderboard
// Requires learner JWT token in Authorization header

// POST /get-learner-rombels
// Balikin rombel aktif yang memang berisi learner yang lagi login
// Request: { data: {} }
// Response: { status: "ok", message: "...", data: [...] }
export const getLearnerRombels = async () => {
  try {
    const response = await api.post('/frontsite-api/v1/learner/leaderboard/get-learner-rombels', {
      data: {},
    });
    return {
      success: response.data?.status === 'ok',
      data: response.data?.data || [],
      message: response.data?.message,
    };
  } catch (error) {
    // Treat 404 as empty state (not error)
    if (error.response?.status === 404) {
      return {
        success: true,
        message: error.response?.data?.message || 'Rombels not found',
        data: [],
      };
    }
    return {
      success: false,
      message: error.response?.data?.message || 'Failed to fetch learner rombels',
      data: [],
    };
  }
};

// POST /get-rombel-learner-stats (Learner)
// Ambil stats seluruh learner di rombel yang sama
// Request: { data: { "course-id": "...", "rombel-id": "..." } }
// Response: { status: "ok", message: "...", data: [...] }
export const getLearnerRombelStats = async (courseId, rombelId) => {
  if (!courseId || !rombelId) {
    return {
      success: false,
      message: 'course-id and rombel-id are required',
      data: [],
    };
  }
  try {
    const response = await api.post('/frontsite-api/v1/learner/leaderboard/get-rombel-learner-stats', {
      data: { 'course-id': courseId, 'rombel-id': rombelId },
    });
    return {
      success: response.data?.status === 'ok',
      data: response.data?.data || [],
      message: response.data?.message,
    };
  } catch (error) {
    // Treat 404 as empty state (not error)
    if (error.response?.status === 404) {
      return {
        success: true,
        message: error.response?.data?.message || 'Rombel learner stats not found',
        data: [],
      };
    }
    return {
      success: false,
      message: error.response?.data?.message || 'Failed to fetch learner rombel stats',
      data: [],
    };
  }
};

// Management Monitoring API
// Base: /frontsite-api/v1/management/monitoring
// Auth: Authorization: Bearer <management/admin JWT>
// Notes: Middleware tetep wajib walaupun controller ga baca `:identity`.

// POST /get-rombels
// Ambil semua rombel aktif buat course tertentu (tanpa filter learner)
// Request: { data: { "course-id": "..." } }
// Response: { status: "ok", message: "...", data: [...] }
export const getRombels = async (courseId = GERMAN_COURSE_ID) => {
  if (!courseId) {
    return {
      success: false,
      message: 'course-id is required',
      data: [],
    };
  }
  try {
    const response = await api.post('/frontsite-api/v1/management/monitoring/get-rombels', {
      data: { 'course-id': courseId },
    });
    return {
      success: response.data?.status === 'ok',
      data: response.data?.data || [],
      message: response.data?.message,
    };
  } catch (error) {
    // Treat 404 as empty state (not error)
    if (error.response?.status === 404) {
      return {
        success: true,
        message: error.response?.data?.message || 'Rombels not found',
        data: [],
      };
    }
    return {
      success: false,
      message: error.response?.data?.message || 'Failed to fetch rombels',
      data: [],
    };
  }
};

// POST /get-rombel-learner-stats
// Ambil stats seluruh learner di rombel yang sama, scoped ke course yg sama
// Request: { data: { "course-id": "...", "rombel-id": "..." } }
// Response: { status: "ok", message: "...", data: [...] }
export const getRombelLearnerStats = async (courseId, rombelId) => {
  if (!courseId || !rombelId) {
    return {
      success: false,
      message: 'course-id and rombel-id are required',
      data: [],
    };
  }
  try {
    const response = await api.post('/frontsite-api/v1/management/monitoring/get-rombel-learner-stats', {
      data: { 'course-id': courseId, 'rombel-id': rombelId },
    });
    return {
      success: response.data?.status === 'ok',
      data: response.data?.data || [],
      message: response.data?.message,
    };
  } catch (error) {
    // Treat 404 as empty state (not error)
    if (error.response?.status === 404) {
      return {
        success: true,
        message: error.response?.data?.message || 'Rombel learner stats not found',
        data: [],
      };
    }
    return {
      success: false,
      message: error.response?.data?.message || 'Failed to fetch rombel learner stats',
      data: [],
    };
  }
};

// Load all management data (phases, subcourses, learner progress)
export const loadAllManagementData = async () => {
  try {
    console.log('🔄 Loading all management data...');

    // Load phases
    const phasesResponse = await getPhases();
    const phases = phasesResponse.data || [];

    // Load subcourses for German course
    const subcoursesResponse = await getSubcourses(GERMAN_COURSE_ID);
    const subcourses = subcoursesResponse.data || [];

    // Load learner progress for the course (aggregated per learner with all subcourse stats)
    const progressResponse = await getLearnerProgress(GERMAN_COURSE_ID);
    const learnerData = progressResponse.data || [];

    console.log('✅ Management data loaded successfully');

    return {
      success: true,
      data: {
        phases,
        subcourses,
        learnerData,
      },
    };
  } catch (error) {
    console.error('❌ Error loading management data:', error);
    return {
      success: false,
      message: error.message || 'Failed to load management data',
      data: {
        phases: [],
        subcourses: [],
        learnerData: [],
      },
    };
  }
};

